import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-container" }
const _hoisted_2 = {
  key: 2,
  class: "open-in-app"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "app-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "app-name" }, "乐道汽车"),
  /*#__PURE__*/_createElementVNode("div", { class: "app-desc" }, "打开 App 获得完整体验")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "open-app-button" }, "App 内打开", -1)

import { fetchAppGateway } from '@/utils/fetch'
import { HIconBackMediumM, HIconShareM } from '@nio-fe/horo-icons'
import { HIconMoveLeftS, HIconShareS } from '@nio-fe/horo-icons-alps'
import NavigationBar from '../components/NavigationBar/index.vue'
import { UniLink, WxSdk } from '@nio-wad/uni-link'
import '@vant/touch-emulator'
import Tracker from '@nio-fe/nio-tracker-web'
import { onMounted, onUnmounted, ref } from 'vue'
import LoadingBox from './LoadingBox.vue'
import StepController from './StepController.vue'
// import { HIconArrowsLeft2xs, HIconShare2xs } from '@nio-fe/horo-icons-fy';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const backIcon = process.config.mockSwap === 'alps' ? HIconMoveLeftS : HIconBackMediumM
const shareIcon = process.config.mockSwap === 'alps' ? HIconShareS : HIconShareM

const isInApp =
  (typeof window._dsbridge !== 'undefined' && window._dsbridge.call) ||
  typeof window._nio_jsbridge_ref !== 'undefined'
const showOpenInApp = ref<boolean>(
  window.location.href.indexOf('channel=livingshare') !== -1 && !isInApp
)
const isWechat = navigator.userAgent.indexOf('MicroMessenger') > -1
if (isWechat && showOpenInApp) {
  const wxSdk = new WxSdk('prod')
  wxSdk._config(location.href, {
    debug: false,
    jsApiList: [],
    openTagList: ['wx-open-launch-app'],
  })
}
const openInAppButtonImage = process.config.openInAppButtonImage
const showWechatMask = ref<boolean>(false)
const swapLivingScheme = process.config.swapLivingScheme
const target = process.config.uniLinkTarget
console.log('====================================')
console.log('swapLivingScheme', swapLivingScheme)
console.log('====================================')

// 如果在 app 里打开了从 3d 直播分享出来的模拟换电链接，需要识别到后自动跳转到 3d 直播
if (
  window.location.href.indexOf('jumpToLiving=1') !== -1 ||
  window.location.href.indexOf('channel=livingshare') !== -1
) {
  try {
    if (isInApp && process.config.swapLivingScheme) {
      ;(window.dsBridge || window._dsbridge)
        .call(
          'openURL',
          process.config.swapLivingScheme
        )(window.dsBridge || window._dsbridge)
        .call('close', '')
    }
  } catch (ex) {
    console.error(ex)
  }
}

// 如果是在 web 中访问了 3d 直播分享出来的链接，在 ios 上会触发走 universal link 的逻辑，
// 由于 universal link 本身会做一次跳转（一个有特殊参数的召回链接），所以需要处理跳转失败时的情况。
// 这个召回 url 理论上只在 app 里打开，如果在浏览器里打开说明 universal link 失败了，这个时候强制跳转到下载页面
if (window.location.href.indexOf('jumpToLiving=1') !== -1 && !isInApp) {
  if (navigator.userAgent.indexOf('MicroMessenger') !== -1) {
    showWechatMask.value = true
  } else {
    window.location.href = process.config.downloadAppUrl
  }
}

const mockSwap = (process.config as { [key: string]: any })['mockSwap']
const cdnBasePublicPath =
  mockSwap === 'alps' ? window.FX_WEBPACK_DYNAMIC_PUBLIC_PATH || '/pe/h5/static' : '/pe/h5/static'
const unityContainer = ref<Element>()
const swapDescriptions = ref([])
const loaded = ref(false)
const progress = ref(0)
const showNavigationBar = window.location.href.indexOf('is_nav_show=false') !== -1 && isInApp
const shareURL = ref(
  window.location.href.indexOf('?') !== -1
    ? window.location.href + '&fromShare=1'
    : window.location.href
)
const urlParams = new URLSearchParams(window.location.href)
function onMenuClick(ev, data) {
  if (data.key === 'share') {
    Tracker.track('mockswaph5_share', {
      refer_page: urlParams.get('from'),
    })
  }
}

function messageHandler(ev) {
  switch (ev?.data?.type) {
    // 初始化
    case 1001: {
      window.postMessageToUnity({
        data: {
          cdnUrl: `${cdnBasePublicPath}/assets/${mockSwap}/unity/Web/`,
          ua: window.navigator.userAgent,
        },
        type: 4121,
        mockSwap,
      })
      break
    }
    // 进度更新
    case 4104: {
      progress.value = ev.data?.data?.progress
      if (progress.value === 100) {
        loaded.value = true
      }
      break
    }
  }
}

onMounted(() => {
  document.body.classList.add(`config-brand-${mockSwap}`)
  unityContainer.value?.appendChild(document.getElementById('unity-canvas') as HTMLElement)
  window.addEventListener('unitymessage', messageHandler)

  window.initUnity && window.initUnity(mockSwap)

  const key = '3d_show_swap_qa'
  fetchAppGateway
    .get(
      `${
        mockSwap === 'alps'
          ? '../101762/alps/app/bff/map/resources/v1/config/select'
          : '../101762/app/api/pe/v1/common/config/select'
      }`,
      {
        params: {
          keys: key,
        },
      }
    )
    .then((res) => {
      const value = (res as any)?.data?.[key]
      if (value) {
        swapDescriptions.value = JSON.parse(value)
      }
    })
})

onUnmounted(() => {
  window.removeEventListener('unitymessage', messageHandler)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showNavigationBar))
      ? (_openBlock(), _createBlock(NavigationBar, {
          key: 0,
          title: "体验换电",
          shareParams: {
      title: '换电有多香，模拟一把就知道～',
      text: '沉浸式体验未来换电补能优势。',
      url: shareURL.value,
      imgUrl: 'https://cdn-fx.nio.com/fx/h5pages-nio/bEaofxdEXPowF8UoRNZif/150-150.png',
    },
          BackButtonComponent: _unref(backIcon),
          shareIcon: _unref(shareIcon),
          onOnMenuClick: onMenuClick
        }, null, 8, ["shareParams", "BackButtonComponent", "shareIcon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (!loaded.value)
        ? (_openBlock(), _createBlock(LoadingBox, {
            key: 0,
            onLoaded: _cache[0] || (_cache[0] = ($event: any) => (loaded.value = true)),
            progress: progress.value
          }, null, 8, ["progress"]))
        : (_openBlock(), _createBlock(StepController, {
            key: 1,
            swapDescriptions: swapDescriptions.value
          }, null, 8, ["swapDescriptions"])),
      _createElementVNode("div", {
        class: "unity-container",
        ref_key: "unityContainer",
        ref: unityContainer
      }, null, 512),
      (showOpenInApp.value && _unref(openInAppButtonImage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "logo",
              src: _unref(openInAppButtonImage)
            }, null, 8, _hoisted_3),
            _hoisted_4,
            _createVNode(_unref(UniLink), {
              openScheme: _unref(swapLivingScheme),
              resourceType: "mock_swap",
              width: "100px",
              height: "36px",
              target: _unref(target)
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["openScheme", "target"]),
            _createElementVNode("div", {
              class: "close-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showOpenInApp.value = false))
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})